export default __webpack_public_path__ + "static/media/fence-1536x418.7577b03d.jpg";